//
//
//
//
//
//

// import Lenis from '@studio-freight/lenis'

export default {
  components: {},
  data () {
    return {
      isReady: false,
      geoInfo: null,
      opacity: 0
    }
  },
  fetchOnServer: false,
  head () {
    const isBlogPost =
      (this.$nuxt.$route.name || '').slice(9, 18) === 'blog-slug'
    const headerAttr = this.$nuxtI18nHead({ addSeoAttributes: true })
    if (isBlogPost && headerAttr.link) {
      delete headerAttr.link
      delete headerAttr.meta
    }

    const { link } = headerAttr
    const isDev = process.env.ENVIRONMENT === 'DEV'
    const url = isDev ? 'https://web.pagsmile.com' : 'https://www.pagsmile.com'
    if (link && link.length) {
      link.forEach((itemLink, index) => {
        const { rel, hid, hreflang } = itemLink
        if (rel === 'alternate') {
          headerAttr.link[index].href = url + headerAttr.link[index].href
          if (hreflang && typeof hreflang === 'string') {
            headerAttr.link[index].hreflang = hreflang.toLowerCase()
          }
        } else if (rel === 'canonical' && hid === 'i18n-can') {
          headerAttr.link[index].href = url + headerAttr.link[index].href
        }
      })
    }
    if (headerAttr.meta) {
      headerAttr.meta.push({
        hid: 'description',
        name: 'description',
        content: this.$t('seo.description')
      })
    }
    return {
      ...headerAttr,
      script: [
        {
          hid: 'baidu-analytics',
          innerHTML: `
          window._agl = window._agl || [];
          (function () {
            _agl.push(
                ['production', '_f7L2XwGXjyszb4d1e2oxPybgD']
            );
            (function () {
                var agl = document.createElement('script');
                agl.type = 'text/javascript';
                agl.async = true;
                agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD';
                var s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(agl, s);
            })();
          })();
          `,
          defer: true
        },
        {
          hid: 'ms-clarity-analytics',
          innerHTML: `(function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "crj28dqj2h");`,
          defer: true
        }
      ],
      __dangerouslyDisableSanitizers: ['script']
    }
  },
  watch: {
    geoInfo (value) {
      const { countryCode } = value || {}
      this.isReady = false
      const queryString = window.location.search
      let pathname = window.location.pathname
        .replace('/zh/', '')
        .replace('/es/', '')
        .replace('/pt/', '')
        .replace('/zh', '')
        .replace('/es', '')
        .replace('/pt', '')
      if (pathname === '/') {
        pathname = ''
      }
      if (pathname.startsWith('/')) {
        pathname = pathname.slice(1)
      }
      if (countryCode.includes('zh')) {
        this.$i18n.locale = 'zh'
        if (window) {
          const currentPath = `/zh/${pathname || ''}${queryString}`
          this.$router.push(currentPath)
        }
      } else if (countryCode.includes('br')) {
        this.$i18n.locale = 'pt'
        if (window) {
          const currentPath = `/pt/${pathname || ''}${queryString}`
          this.$router.push(currentPath)
        }
      } else if (countryCode.includes('es')) {
        this.$i18n.locale = 'es'
        if (window) {
          const currentPath = `/es/${pathname || ''}${queryString}`
          this.$router.push(currentPath)
        }
      } else {
        this.$i18n.locale = 'en'
        const currentPath = `/${pathname || ''}${queryString}`
        // eslint-disable-next-line no-console
        // console.log('currentPath=>', currentPath)
        if (window) {
          this.$router.push(currentPath)
        }
      }
      this.opacity = 100
      setTimeout(() => {
        this.updateGeoInfo(value)
        this.isReady = true
      }, 500)
    }
  },
  mounted () {
    this.isReady = true
    // 根绝浏览器国家判断语言，巴西 中国 西班牙以外都是英语
    const curLocale = (
      navigator.language || navigator.browserLanguage
    ).toLowerCase()
    this.geoInfo = { countryCode: curLocale }

    // const lenis = new Lenis({
    //   duration: 2
    // })
    // // lenis.on('scroll', (e) => {
    // //   console.log(e)
    // // })
    // function raf (time) {
    //   lenis.raf(time)
    //   requestAnimationFrame(raf)
    // }
    // requestAnimationFrame(raf)
  },
  methods: {
    checkGeoLocation (code) {
      if (code === 'en') {
        const { countryCode } = this.geoInfo || {}
        const { locale } = this.$i18n
        if (countryCode && countryCode === 'BR' && locale !== 'en') {
          this.$i18n.locale = 'en'
          if (this.sidebarActive) {
            this.sidebarActive = false
          }
        }
      }
    },
    updateGeoInfo (value) {
      if (value) {
        this.$nuxt.$emit('updateGeoInfo', value)
      }
    }
  }
}
